import SharedProcessingTimeSection, { type ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Predictable turnaround",
      "Ideal for upcoming trips",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service",
      "Good for planned travel",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "Workload & wait times shift with shutdowns and budget fights",
      "In-person clerk appointment required",
      "No document review — errors cause rejection",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Can't upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Appointment required — no walk-ins allowed",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis",
      "Expect to wait all day or return next day",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function StJosephProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="St. Joseph"
      headingExtra="MO"
      introText="St. Joseph travelers — Missouri Western State University students, agriculture exporters heading to Mexico and Canada, I-29 business travelers, and Buchanan County families — have several passport options. Here is how they compare, and why most St. Joseph residents choose a registered State Department courier rather than gambling on Kansas City's lack of passport agencies or the 280-mile drive to St. Louis."
      options={options}
      emergencyDescription="Missouri has only 1 passport agency (St. Louis, ~280 miles via I-70, 4.5+ hours) serving 6M+ statewide residents. Kansas City is only 55 miles south — but KC has ZERO passport agencies, leaving St. Joseph in a cruel paradox: close to a major metro, yet completely dependent on a single agency nearly 300 miles away. The Missouri River has flooded catastrophically three times since 1993 — when I-29 is underwater between St. Joseph and Kansas City, the nearest usable interstate route requires a 100+ mile detour. Spring tornado season (March–June) makes I-70 across Missouri one of the most dangerous driving corridors in America — the same stretch that produced the deadliest tornado in U.S. history (Joplin, 2011). St. Louis's single agency also serves border-region residents from Illinois and Arkansas, making appointments fiercely competitive across three states."
      disclaimerText="*Processing speed depends on eligibility and documentation. Not all applicants qualify for Regional Agency Processing."
    />
  );
}